export default "__VITE_ASSET__181c95be__"